// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-custom-height.v-text-field--outlined[data-v-7295cd59] .v-input__control > .v-input__slot {\n  min-height: 36px !important;\n  max-height: 36px !important;\n}\n.inf-alert-yellow.v-alert--outlined[data-v-7295cd59] {\n  border-color: var(--light-yellow-700) !important;\n  background-color: var(--light-yellow-100) !important;\n}\n", ""]);
// Exports
module.exports = exports;
